import * as React from 'react';

import CollapseM, { CollapseProps } from '@mui/material/Collapse';

export interface Props extends CollapseProps {
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM node and a done callback.
   * Allows for more fine grained transition end logic.
   * Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener?: CollapseProps['addEndListener'];
  /**
   * The content node to be collapsed.
   */
  children?: React.ReactNode;
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes?: CollapseProps['classes'];
  /**
   * Override or extend the styles applied to the component.
   * See CSS API below for more details.
   */
  className?: string;
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   */
  collapsedSize?: string;
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component?: CollapseProps['component'];
  /**
   * If `true`, the component will transition in.
   */
  in?: boolean;
  /**
   * The transition orientation.
   */
  orientation?: CollapseProps['orientation'];
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout?: CollapseProps['timeout'];
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   * See the `sx` page for more details. https://mui.com/system/the-sx-prop/
   */
  sx?: CollapseProps['sx'];
}

function Collapse(props: Props) {
  return <CollapseM {...props}>{props.children}</CollapseM>;
}

export default Collapse;
